import React from 'react';
import styled from 'styled-components';
import type { Message } from '../types';
import MessageBubble from './common/MessageBubble';

type RecentMessagesChatProps = {
  recentMessages: Message[];
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 545px;
  overflow-y: auto;
  padding: 20px;
  border-top: 2px solid #e4e5e7;
`;

const RecentMessagesChat = ({ recentMessages }: RecentMessagesChatProps) => {
  return (
    <Container>
      {recentMessages.map((message, i) => (
        <MessageBubble
          key={i}
          name={message.senderName || 'Customer'}
          type={message.type}
          messageBody={message.messageBody}
          date={message.date}
        />
      ))}
    </Container>
  );
};

export default RecentMessagesChat;
